<div class="staff-leads core-screen">
  <div class="staff-leads__section-tabs" role="tablist">
    @for (sectionItem of sections; track sectionItem.id) {
      <a
        class="staff-leads__section-tab"
        [class.staff-leads__section-tab--active]="section() === sectionItem.id"
        [routerLink]="sectionLink(sectionItem.id)"
        role="tab"
        [attr.aria-selected]="section() === sectionItem.id"
      >
        {{ sectionItem.labelKey | translate }}
      </a>
    }
  </div>

  @if (accessDenied()) {
    <p class="hint error">{{ 'STAFF.LEADS.STATE.ACCESS_DENIED' | translate }}</p>
  } @else {
    <div class="search-section">
      <lib-not-input
        type="text"
        [placeholder]="'STAFF.LEADS.SEARCH.PLACEHOLDER' | translate"
        [ariaLabel]="'STAFF.LEADS.SEARCH.ARIA' | translate"
        [ngModel]="searchQuery()"
        (ngModelChange)="onSearchChange($event)"
        [hideErrorBlock]="true"
      />
    </div>

    <div class="filters-section filters-section--scroll">
      <div class="filters filters--scroll" role="tablist">
        @for (f of statusFilters; track f.id) {
          <button
            type="button"
            class="chip"
            [class.active]="statusFilter() === f.id"
            (click)="setStatusFilter(f.id)"
            role="tab"
            [attr.aria-selected]="statusFilter() === f.id"
          >
            {{ f.labelKey | translate }}
          </button>
        }
      </div>
    </div>

    <div class="list">
      @if (error()) {
        <p class="hint error">{{ error() }}</p>
      } @else if (loading()) {
        <p class="hint" role="status">{{ 'common.loading' | translate }}</p>
      } @else if (items().length === 0) {
        <section class="empty" role="status" aria-live="polite">
          @if (hasFiltersActive()) {
            <h2 class="empty-title">{{ 'STAFF.LEADS.EMPTY.FILTERED' | translate }}</h2>
            <p class="empty-hint">{{ 'STAFF.LEADS.EMPTY.FILTERED_HINT' | translate }}</p>
          } @else {
            <h2 class="empty-title">{{ 'STAFF.LEADS.EMPTY.TITLE' | translate }}</h2>
            <p class="empty-hint">{{ 'STAFF.LEADS.EMPTY.HINT' | translate }}</p>
          }
        </section>
      } @else {
        @for (row of items(); track row.id) {
          @let contactLine = cardContactLine(row);
          <button type="button" class="card" (click)="onOpen(row.id)">
            <div class="card-top">
              <span class="name">{{ cardPrimaryLine(row) }}</span>
            </div>
            <div class="badges">
              <span class="badge badge--id">{{ formatStaffLeadShortId(row.id) }}</span>
              <span class="badge" [attr.data-status]="row.status">{{
                statusLabelKey(row.status) | translate
              }}</span>
            </div>
            @if (contactLine) {
              <div class="meta muted contact-line">{{ contactLine }}</div>
            }
            <div class="meta muted">{{ kindLabelKey(row.kind) | translate }}</div>
            <div class="meta muted">
              {{ row.created_at | date: 'd MMMM y, HH:mm' }}
            </div>
          </button>
        }
        @if (hasMore()) {
          <lib-not-button
            class="load-more"
            [text]="'STAFF.LEADS.LOAD_MORE' | translate"
            [color]="'#140342'"
            [bgColor]="'#E8F9F7'"
            [width]="'100%'"
            [size]="'big'"
            [action]="{ type: 'action' }"
            [disabled]="loadingMore()"
            (actionEvent)="loadMore()"
          />
        }
      }
    </div>
  }
</div>
